import './Campain.css';
import React from 'react';
import i18n from '../i18n';
import request from '../request';
import history from '../history';
import { useParams } from "react-router-dom";


function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class Campain extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            campain: [],
            id: this.props.params.id
        };
    }
    
    onLanguageChange = () => {
        this.forceUpdate();
    }

    componentDidMount() {
        this.onHistoryChangeUnlisten = history.listen(() => {
            this.setState({
                ...this.state,
                id: this.props.params.id
            }, () => {
                this.getArticles()
            });
        });
        this.getArticles()
        this.unlistenOnLanguageChange = i18n.onLanguageChange(this.onLanguageChange);
    }

    componentWillUnmount() {
        this.unlistenOnLanguageChange();
    }
    
    getArticles() {
        request.get(`api/campain/${this.props.params.id}`).then((response) => {
            this.setState({
                ...this.state,
                campain: response.data
            }, () => {
                if(this.state.campain)
                    document.title = i18n.toggle(this.state.campain.caption_general, this.state.campain.caption_general_en);
            });
            
        });
    }
    
    render() {
        return (
            <div className='column container bg-white'>
                {/* <h3 className='title top-title'>ΟΡΟΙ ΚΑΙ ΠΡΟΥΠΟΘΕΣΕΙΣ ΧΡΗΣΗΣ</h3> */}
                <div id="terms-wrapper" style={{minHeight: "60vh"}}>
                    {this.state.campain &&
                            <div className='content'>
                                <h3 className='title text-center'>{i18n.toggle(this.state.campain.caption_general, this.state.campain.caption_general_en)}</h3>
                                <div className='term-content'>
                                    <p id="terms-wrapper" dangerouslySetInnerHTML={{__html: i18n.toggle(this.state.campain.description, this.state.campain.description_en)}}>
                                        
                                    </p>
                                </div>
                            </div>
                        
                    }
                </div>
                
            </div>
        );
    }
}
export default withParams(Campain);